export const ONE_TIME = 'OneTime';
export const FUTURE = 'Future';
export const CONTINUING = 'Continuing';
export const OTHER = 'Other';

export const foreignBenefitFrequencyTypeOptions = [ONE_TIME, FUTURE, CONTINUING, OTHER];

export const foreignBenefitTypeOptions = [
  'Educational',
  'Medical',
  'Retirement',
  'SocialWelfare',
  'Other',
];

export const foreignBenefitFrequencyOptions = [
  'Annually',
  'Quarterly',
  'Monthly',
  'Weekly',
  'Other',
];

// PVQ Dropdown values
export const foreignGovernmentServiceOptions = [
  'Military or Armed Forces',
  'Intelligence Service',
  'Diplomatic Service',
  'Security Service',
  'Militia',
  'Other Defense Force',
  'Other Government Force',
  'Other'
];

// PVQ Dropdown values
export const foreignContactMethodOptions = [
  'In-person',
  'Telephone',
  'Electronic means (for example, email, texting, chat rooms)',
  'Written correspondence',
  'Other',
  'None',
];

// PVQ Dropdown values
export const foreignContactFrequencyOptions = [
  'Annually',
  'Quarterly',
  'Monthly',
  'Weekly',
  'Daily',
  'Other',
];

// PVQ Dropdown values
export const foreignContactRelationshipOptions = [
  'Friend',
  'Schoolmate',
  'Neighbor',
  'Work Associate',
  'Landlord',
  'Other',
];

// PVQ Dropdown values
export const foreignNationalWorkOptions = [
  'Military or Armed Forces',
  'Security Service',
  'Intelligence Service',
  'Other Government Agency',
  'Defense Industry',
  'Foreign Movement (such as a social, political, or religious movement)',
  'They are not associated with any of the above.',
];

// PVQ Dropdown values
export const foreignInterestOwnerOptions = [
  'Myself',
  'Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
  'Person with whom you\'re in a committed, spouse-like relationship',
  'Dependent children',
];

// PVQ Dropdown values
export const foreignInterestCoOwnerOptions = [
  'Yourself',
  'Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
  'Person with whom you\'re in a committed or spouse-like relationship',
  'Dependent children',
  'Other relative',
  'Friend',
  'Business Associate',
  'Other',
  'Common/co-parent',
];

// PVQ Dropdown values
export const STOCK = 'Stocks';
export const BONDS = 'Bonds';
export const OWNER = 'Ownership of corporate entities';
export const CORP = 'Corporate interests held in specific geographical or economic sectors';
export const EFT = 'Exchange traded funds (ETFs) held in specific geographical or economic sectors';
export const REALESTATE = 'Real estate in a foreign country';
export const PROPERTY = 'Other Property (non-real estate)';
export const INVESTMENTS = 'Investments';
export const BANK = 'Bank Account';
export const OTHR = 'Other (Do not list financial interests in companies or diversified mutual funds or diversified ETFs that are publicly traded on a U.S. exchange.)';

export const foreignFinancialInterestOptionsList = Object.freeze({
  STOCK,
  BONDS,
  OWNER,
  CORP,
  EFT,
  REALESTATE,
  PROPERTY,
  INVESTMENTS,
  BANK,
  OTHR,
} as const);

// Excludes OTHR and REALESTATE
export const FINANCIAL_FOREIGN_INTEREST_VALUES: readonly string[] = [
  STOCK,
  BONDS,
  OWNER,
  CORP,
  EFT,
  PROPERTY,
  INVESTMENTS,
  BANK,
];

export const foreignFinancialInterestOptions = Object.values(foreignFinancialInterestOptionsList);

// PVQ Dropdown values
export const foreignRealEstateOptions = [
  'Home',
  'Business',
  'Land',
  'Other',
];

// PVQ Dropdown values
export const foreignFinancialInterestHowAcquiredOptions = [
  'Bought it',
  'It was a gift',
  'Inherited it',
  'Other',
];

// PVQ Dropdown values
export const foreignFinancialInterestHowRelinquishedOptions = [
  'Sold it',
  'Lost it',
  'Gave it away',
  'Other',
];

// PVQ Dropdown values
export const foreignFinancialInterestControllerOptions = [
  'Company or organization controlled',
  'Another person controlled (other than the owner or co-owner)',
  'No one controlled this foreign financial interest on the owner or co-owner\'s behalf',
  'Other',
];

// PVQ Dropdown values
export const foreignBenefitTypes = [
  'Educational',
  'Medical',
  'Retirement',
  'Social Welfare',
  'Other',
];

// PVQ Dropdown values
export const foreignBusinessImmediateFamilyOptions = [
  'Myself',
  'Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
  'Person with whom you\'re in a committed, spouse-like relationship',
  'Parent',
  'Stepparent',
  'Child (including adopted/foster)',
  'Stepchild',
  'Sibling',
  'Stepsibling',
  'Half-sibling',
  'Parent-in-law',
  'Guardian',
];

// PVQ Dropdown values
export const foreignBusinessInvolvementOptions = [
  'I owned the business',
  'I co-owned the business',
  'I was a business consultant',
  'I provided financial support',
  'Other',
];

// PVQ Dropdown values
export const foreignAgencyOptions = [
  'Military or Armed Forces',
  'Intelligence Service',
  'Security Service',
  'Diplomatic Service',
  'Embassy',
  'Consulate',
  'Other',
  'I don\'t know',
];

// PVQ Dropdown values
export const foreignNationalSponsorReasonOptions = [
  'So they could attend school in the U.S.',
  'So they could work in the U.S.',
  'So they could pursue permanent U.S. residency',
  'Other',
];

export const anotherPerson = 'Another person controlled (other than the owner or co-owner)';
export const companyOrOrg = 'Company or organization controlled';
